import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export const DefaultIconViewBox = '0 0 24 24';

export const IconMaxSize = {
  [Icon.Seat]: 24
};

export const IconViewBoxes = {
  '0 0 120 40': [
    Icon.RappiProHorz,
  ],
  '0 0 28 28': [
    Icon.AppGallery,
  ],
  '0 0 25 24': [
    Icon.Flight1, Icon.Flight2, Icon.Check, Icon.Close, Icon.Add, Icon.Home,
    Icon.CancelCircleOutline, Icon.Bed, Icon.WorkOutline, Icon.PersonOutline,
    Icon.Wifi, Icon.Gym, Icon.Pool, Icon.Low, Icon.Medium, Icon.High, Icon.BigHotel,
    Icon.Power, Icon.Wifi, Icon.Without, Icon.Children, Icon.PhoneIphone,
    Icon.AddLocation, Icon.Restaurant, Icon.MoreVert, Icon.Gallery,
    Icon.HeartOutline, Icon.Family, Icon.Pet, Icon.ShoppingBag, Icon.Accessibility,
    Icon.Market, Icon.VIP, Icon.Gift, Icon.Business, Icon.Key, Icon.CivitatisFlat,
  ],
  '0 0 24 20': [
    Icon.EconomicHotel,
  ],
  '0 0 24 6': [
    Icon.Civitatis,
  ],
  '0 0 22 24': [
    Icon.PlayStore,
  ],
  '0 0 21 5': [
    Icon.MoreThanTwoScales,
  ],
  '0 0 21 14': [
    Icon.InFlightEntertainment,
  ],
  '0 0 21 16': [
    Icon.Email,
  ],
  '0 0 21 18': [
    Icon.Roundtrip, Icon.Cashback, Icon.DepartureDuration,
  ],
  '0 0 21 20': [
    Icon.PlaneAlt, Icon.Departure, Icon.Search, Icon.StartPoint, Icon.Seat,
    Icon.EditOutline, Icon.Promotion, Icon.Clock, Icon.Divide, Icon.OrderAgain,
    Icon.Profile, Icon.ProfileCircle, Icon.Share, Icon.General,
  ],
  '0 0 21 24': [
    Icon.ChevronRight, Icon.SeatPitch,
  ],
  '0 0 20 16': [
    Icon.List, Icon.NoCash, Icon.CreditCard,
  ],
  '0 0 20 18': [
    Icon.Hotels, Icon.Packages, Icon.Morning, Icon.Afternoon, Icon.MorningMoon,
  ],
  '0 0 20 20': [
    Icon.Autos, Icon.WithoutLuggage, Icon.Support, Icon.Parking, Icon.Expensive,
    Icon.Monetization, Icon.Info, Icon.Warning, Icon.RoomSize, Icon.TopUp,
    Icon.Refund, Icon.Stop,
  ],
  '0 0 20 25': [
    Icon.Apple,
  ],
  '0 0 19 6': [
    Icon.Scale, Icon.Twoscales,
  ],
  '0 0 19 16': [
    Icon.Filter,
  ],
  '0 0 19 20': [
    Icon.Calendar, Icon.CopyToClipboard, Icon.HotOutline,
  ],
  '0 0 18 14': [
    Icon.ArrowRight, Icon.ArrowLeft,
  ],
  '0 0 18 20': [
    Icon.Buses, Icon.MarriottBonvoyFlat, Icon.IntermediatePrice,
  ],
  '0 0 17 4': [
    Icon.Process,
  ],
  '0 0 17 16': [
    Icon.Coupon,
  ],
  '0 0 17 20': [
    Icon.Backpack, Icon.HandLuggage, Icon.Notification, Icon.Rock, Icon.NoMoney, Icon.Trash,
    Icon.Security, Icon.CheckProtection, Icon.Cooperative, Icon.Ticket,
  ],
  '0 0 17 24': [
    Icon.SeatWidth, Icon.SeatInclination,
  ],
  '0 0 16 16': [
    Icon.ImageNotAvailable, Icon.Facebook, Icon.Instagram,
  ],
  '0 0 16 20': [
    Icon.Location, Icon.AccountState,
  ],
  '0 0 15 20': [
    Icon.SwapVert, Icon.Points,
  ],
  '0 0 14 12': [
    Icon.Group,
  ],
  '0 0 14 18': [
    Icon.ArrowUp, Icon.ArrowDown,
  ],
  '0 0 14 20': [
    Icon.Activities, Icon.Luggage, Icon.Seats,
  ],
  '0 0 13 20': [
    Icon.Phone,
  ],
  '0 0 12 18': [
    Icon.Expand,
  ],
  '0 0 10 20': [
    Icon.MoneyIcon,
  ],
  '0 0 455.1 129.9': [
    Icon.MarriottBonvoy
  ],
  '6.45 6.05 10.88 10.58': [
    Icon.SentimentNegative,
  ],
  '6.52 6.48 10.84 10.71': [
    Icon.SentimentNeutral,
  ],
  '6.6 6.5 10.83 10.86': [
    Icon.SentimentPositive,
  ],
}
